// Generated by extract-enums.sh — do not edit manually

export enum MessageAttachmentTypeEnum {
  FILE = "file",
}

export enum MessageTypeEnum {
  URGENT = "urgent",

  DELAY = "delay",

  FOLLOW_UP = "follow_up",

  AWAITED_INPUT = "awaited_input",

  SYSTEM_DEFAULT = "system_default",
  SYSTEM_SUCCESS = "system_success",
  SYSTEM_INFO = "system_info",

  MESSAGE = "message",

  STATUS_UPDATE = "status_update",

  PATIENT_CONSULTATION_PRIORITY = "patient_consultation_priority",
  // manual
  PATIENT_CONSULTATION_DONE = "patient_consultation_done",
  // manual
}

export enum PriorityEnum {
  URGENT = "urgent",

  HIGH = "high",

  MEDIUM = "medium",

  LOW = "low",
}

export enum RoomTypeEnum {
  DIRECT = "direct",

  GROUP = "group",

  PATIENT_MAIN = "patient:main",
  PATIENT_INTERNAL = "patient:internal",
  PATIENT_PATIENT = "patient:patient",

  INVITE = "invite",

  REFERRAL_PAID_PROPOSAL = "referral:paid_proposal",
}
